import { types } from '../../actions/search';
import * as routeTypes from '../../routes/types';

const initialState = '';

const toSearchText = str => str.replace(/-/g, ' ');

const handleSearchSetQueryText = (state, action) => toSearchText(action.payload.queryText);
const handleRouteSearchQueryText = (state, action) => toSearchText(action.payload.queryText.toString());

const queryText = (state = initialState, action) => {
  const { type } = action;

  if (type.indexOf('route/') === 0) {
    switch (type) {
      case routeTypes.ROUTE_SEARCH_QUERY_TEXT:
        return handleRouteSearchQueryText(state, action);
      case routeTypes.ROUTE_HOME:
        return '';
      default:
        return state;
    }
  }

  switch (type) {
    case types.SET_SEARCH_QUERY_TEXT:
      return handleSearchSetQueryText(state, action);
    default:
      return state;
  }
};

export default queryText;

export const getSearchQueryText = state => state.search.queryText;



// WEBPACK FOOTER //
// ./src/reducers/search/queryText.js